/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import { smallDevice, mediumDevice, colors, largeDevice } from "../styles/common";
import { CaretLeft } from "./ui/icons/CaretLeft";
import { CaretRight } from "./ui/icons/CaretRight";
import { mediaFeatures } from "../styles/common";
const breakpoints = [smallDevice, mediumDevice];
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`);
const SCROLL_PX = 90;
const navBarIconWidth = 60, navBarWeAreHiringWidth = 250, navBarWeAreHiringWidthMediumDevice = 200, navBarActiveCartWidth = 100, navBarActiveCartWidthMediumDevice = 160, navBarInsiderLogoWidth = 250, navBarInsiderLogoWidthMediumDevice = 200, navBarCityWidth = 240, navBarCityWidthMediumDevice = 180;
const transition = "all 0.3s ease-in-out";
const HorizontalScrollContainerStyles = `
	position: relative;
	@media (max-width: ${smallDevice - 0.1}em) {
		width: 100%;
	}
`;
const BannerPreviousStyles = `
	user-select: none;
	color: #ffffff;
	margin-top: -30px;
	@media screen and (min-width: ${smallDevice}em) {
		left: -24px;
		background: linear-gradient(90deg,#373435 70%,rgba(55,52,53,.5) 90%,rgba(55,52,53,0));
	}
`;
const BannerNextStyles = `
	user-select: none;
	color: #ffffff;
	margin-top: -30px;
	@media screen and (min-width: ${smallDevice}em) {
		right: -24px;
		background: linear-gradient(270deg,#373435 70%,rgba(55,52,53,.5) 90%,rgba(55,52,53,0));
	}
`;
const CarouselPrevoiusAndNextStyles = `
	display: none;
	position: absolute;
	width: 48px;
	height: 60px;
	top: 50%;
	margin-top: 24px;
	z-index: 10;
	background-color: ${colors.greyIconHeading};
	text-align: center;
	cursor: pointer;

	svg {
		display: inline-block;
		width: 9px;
    	padding-top: 18px;
		fill: ${colors.white};
	}

	@media screen and (min-width: ${smallDevice}em) {
		display: block;
	}

	::before {
		font-size: 26px;
		display: inline-block;
		line-height: 48px;
	}
`;
const BannerScrollStyles = `
	display: none;
	float: left;
	height: 100%;
	@media screen and (min-width: ${largeDevice}em) {
		display: block;
		width: calc(
			100vw - ${navBarIconWidth}px * 3 - ${navBarWeAreHiringWidth}px - ${navBarActiveCartWidth}px -
				${navBarInsiderLogoWidth}px - ${navBarCityWidth}px
		);
	}
	@media screen and (min-width: ${mediumDevice}em) and (max-width: ${largeDevice - 0.01}em) {
		display: block;
		width: calc(
			100vw - ${navBarIconWidth}px * 3 - ${navBarWeAreHiringWidthMediumDevice}px - ${navBarActiveCartWidthMediumDevice}px -
				${navBarInsiderLogoWidthMediumDevice}px - ${navBarCityWidthMediumDevice}px
		);
	}
`;
const HorizontalScrollListStyles = {
    overflow: "hidden"
};
const HorizontalScrollElementStyles = {
    transition: transition
};
const CategoryContainerStyles = `
	width: 60vw;
	float: none;
	margin-left: auto;
	margin-right: auto;
	text-align: center;
	${HorizontalScrollContainerStyles}
	@media screen and ${mediaFeatures["for-mobile-and-tablet"]} {
		width: 100%;
	}
`;
const CategoryIconsStyles = `
	cursor: pointer;
	user-select: none;
	color: #ffffff;
	margin-top: -30px;

	svg {
		display: inline-block;
		width: 14px;
    	padding-top: 5px;
		fill: ${colors.insiderRed};
	}

	@media screen and (min-width: ${smallDevice}em) {
		background: none;
		color: ${colors.lightRed};
		font-size: 26px;
		width: 60px;
		height: 60px;
    	background-color: ${colors.white};
	}
`;
const CategoryPreviousStyles = `
	${CategoryIconsStyles};
	@media screen and (min-width: ${smallDevice}em) {
		left: -24px;
	}
`;
const CategoryNextStyles = `
	${CategoryIconsStyles};
	@media screen and (min-width: ${smallDevice}em) {
		right: -24px;
	}
`;
class ArrowBar extends React.PureComponent {
    constructor(props) {
        super(props);
        this.getSelfWidth = () => {
            return this.content.current.offsetWidth;
        };
        this.getContentWidth = () => {
            return this.content.current.children[0].offsetWidth;
        };
        this.resetArrows = () => {
            if (this.content && this.content.current.children && this.content.current.children.length > 0) {
                const contentWidth = this.getContentWidth();
                const selfWidth = this.getSelfWidth();
                if (contentWidth > selfWidth) {
                    if (this.state.left === 0) {
                        this.setState(() => {
                            return {
                                leftEnabled: false,
                                rightEnabled: true
                            };
                        });
                    }
                    else {
                        this.setState(() => {
                            return {
                                leftEnabled: true,
                                rightEnabled: false
                            };
                        });
                    }
                }
                else {
                    this.setState(() => {
                        return {
                            left: 0,
                            leftEnabled: false,
                            rightEnabled: false
                        };
                    });
                }
            }
        };
        this.content = React.createRef();
        this.state = {
            left: 0,
            leftEnabled: false,
            rightEnabled: false,
            mounted: false
        };
        this.onClickLeft = this.onClickLeft.bind(this);
        this.onClickRight = this.onClickRight.bind(this);
    }
    componentDidMount() {
        window.addEventListener("resize", this.resetArrows);
        this.setState(() => {
            return {
                mounted: true
            };
        });
        this.resetArrows();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) {
            this.resetArrows();
        }
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resetArrows);
    }
    moveTo(position) {
        let left;
        let leftEnabled = true;
        let rightEnabled = true;
        const minLeft = this.getSelfWidth() - this.getContentWidth();
        if (position > 0) {
            left = 0;
            leftEnabled = false;
        }
        else if (position < minLeft) {
            left = minLeft;
            rightEnabled = false;
        }
        else {
            left = position;
        }
        if (this.getSelfWidth() >= this.getContentWidth()) {
            left = 0;
            leftEnabled = false;
            rightEnabled = false;
        }
        return {
            left,
            leftEnabled,
            rightEnabled
        };
    }
    onClickLeft() {
        this.resetArrows();
        if (!this.state.leftEnabled) {
            return;
        }
        this.setState(prevState => {
            const result = prevState.left + SCROLL_PX;
            return this.moveTo(result);
        });
    }
    onClickRight() {
        this.resetArrows();
        if (!this.state.rightEnabled) {
            return;
        }
        this.setState(prevState => {
            const result = prevState.left - SCROLL_PX;
            return this.moveTo(result);
        });
    }
    render() {
        const { children, carouselType } = this.props;
        return (<div css={carouselType == "banner"
                ? [css(HorizontalScrollContainerStyles), css(BannerScrollStyles)]
                : css(CategoryContainerStyles)}>
				<span css={carouselType == "banner"
                ? [css(CarouselPrevoiusAndNextStyles), css(BannerPreviousStyles)]
                : [css(CarouselPrevoiusAndNextStyles), css(CategoryPreviousStyles)]} style={{ display: !this.state.leftEnabled || !this.state.mounted ? "none" : "inline-block" }} onClick={this.onClickLeft}>
					<CaretLeft />
				</span>
				<div css={Object.assign({}, HorizontalScrollListStyles)}>
					<div ref={this.content} css={Object.assign({}, HorizontalScrollElementStyles)} style={{
                transform: `translateX(${this.state.left}px)`
            }}>
						{children}
					</div>
				</div>
				<span css={carouselType == "banner"
                ? [css(CarouselPrevoiusAndNextStyles), css(BannerNextStyles)]
                : [css(CarouselPrevoiusAndNextStyles), css(CategoryNextStyles)]} style={{ display: !this.state.rightEnabled || !this.state.mounted ? "none" : "inline-block" }} onClick={this.onClickRight}>
					<CaretRight />
				</span>
			</div>);
    }
}
export default ArrowBar;
